var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"circle",class:{ small: _vm.small, active: _vm.active }},[_c('div',{staticClass:"room-button-content"},[_c('svg-icon',{attrs:{"icon":_vm.icon,"width":"35","height":"35"}}),_c('span',[_vm._v(_vm._s(_vm.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }